import { AnyObject } from '@store/types';
import { TableCellParams } from 'chaika-types';
import { TableFieldCellType } from 'chaika-enums';

import groupBy from 'lodash/groupBy';

import { translate } from '@chaika/i18n/helper';
import { LaboratoryTestResultParams } from 'chaika-frontend-types/frontend-cms';
import { TableData } from '@components/Fields/Table/types';

export class LaboratoryTestTableDataHelper {
    private static columnNames: string[] = [
        'name',
        'value',
        'unit',
        'refMin',
        'refMax',
        'refText',
        'comment',
        'isOutOfRange',
    ];

    public static getNamesWithValues(params: LaboratoryTestResultParams[]): string[] {
        // @ts-expect-error
        return this.columnNames.filter(name => params.some(item => item[name] && item[name] !== 0));
    }

    public static groupResult(params: LaboratoryTestResultParams[]): Record<string, LaboratoryTestResultParams[]> {
        const correctedParams = (params || []).map(item => (item.name === item.group ? { ...item, group: '' } : item));
        return groupBy(correctedParams, 'group');
    }

    public static createTitleCells(names: string[]): TableCellParams[] {
        const titles: AnyObject = {
            name: translate('parameter'),
            value: translate('value'),
            unit: translate('unit'),
            refMin: translate('minRefValue'),
            refMax: translate('maxRefValue'),
            refText: translate('refValue'),
            comment: translate('comment'),
        };

        return names.map(name => ({
            name,
            type: TableFieldCellType.Title,
            title: titles[name] ?? '',
        }));
    }

    public static createDataCells(names: string[], count: number): TableCellParams[][] {
        const result: TableCellParams[][] = [];

        let row: TableCellParams[];
        for (let i = 0; i < count; i++) {
            row = names.map(name => ({
                type: TableFieldCellType.Input,
                name: this.createCellName(name, i),
            }));
            result.push(row);
        }

        return result;
    }

    public static createTableData(names: string[], params: LaboratoryTestResultParams[]): TableData {
        return params.reduce((acc: AnyObject, cur: AnyObject, index) => {
            for (const name of names) {
                const cellName = this.createCellName(name, index);
                const value = cur[name];

                acc[cellName] =
                    name === 'comment' && !!value ? value.replaceAll('\\n', '\n').replaceAll('\\r', '\r') : value;
            }

            return acc;
        }, {});
    }

    private static createCellName(name: string, index: number): string {
        const nameDictionary: AnyObject = {
            refMin: 'min_for_value',
            refMax: 'max_for_value',
            refText: 'text_for_value',
            isOutOfRange: 'out_of_range_for_value',
        };

        return `${nameDictionary[name] ?? name}_${index}`;
    }
}
